import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * ADF Changelog entry from database
 */
export interface AdfChangelogEntry {
  id: string;
  version: string;
  release_date: string;
  changes: string[];
  is_current: boolean;
  display_order: number;
  created_at: string;
  updated_at: string;
}

/**
 * Hook to fetch ADF changelog entries from the database
 */
export function useAdfChangelog() {
  return useQuery({
    queryKey: ['adf-changelog'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('adf_changelog')
        .select('*')
        .order('display_order', { ascending: true });

      if (error) throw error;

      return (data || []).map(entry => ({
        ...entry,
        changes: (entry.changes as unknown) as string[],
      })) as AdfChangelogEntry[];
    },
    staleTime: 10 * 60 * 1000, // 10 minutes - reference data
  });
}

/**
 * Get the current version from changelog entries
 */
export function getCurrentVersion(entries: AdfChangelogEntry[] | undefined): AdfChangelogEntry | undefined {
  return entries?.find(e => e.is_current);
}
